import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import axios from "axios";
import {  Link, useNavigate } from 'react-router-dom'
import banner from '../../../images/banners/login.jpg'
import loading from '../../../images/spin.gif'

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export default function Users_wallet() {

  const adminno = sessionStorage.getItem('adminno')
  const navigate=useNavigate()
  if(adminno == 0 || adminno == '' || !adminno){
    navigate('/wallet-dashboard/signin/')
  }

  //console.log(adminno)
  
function walletDashboard_logout(){
  sessionStorage.removeItem('adminno')
 // alert("user logged out successfully");//
  navigate('/wallet-dashboard/signin/')
}

    const url=window.location.href
    const user_id = url.split("/").pop();
   const [userid, setawb] = useState(user_id);

  const API_PATH = `${SERVER_URL}user_transactions.php`; 
  //const API_PATH = "http://localhost:8000/user_transactions.php"; 
  const [orders, setorders] = useState('')
  const [ordercount, setordercount] = useState(0)
  const [data, setdata2] = useState([])
  const [isload, setisload] = useState(true)
  useEffect(() => {

      axios({
        method: 'post',
        url: `${API_PATH}`,
        data:userid
      })
        .then((res) => {
          setisload(false)
         
          setordercount(res.data.length)
      
          setdata2(res.data)
       setorders(JSON.parse(JSON.stringify(res.data)))
       
        }
        )
        .catch((err) => console.log(err))
  
    }, [])
  
  const columns = [
     
      {
        name: "OrderID",
        selector: "OrderID",
        sortable: true
       
      },
      {
          name: "user_id",
          selector: "user_id",
          sortable: true
        }
      ,
      {
          name: "awbno",
          selector: "awbno",
          sortable: true
        }
        ,
      {
          name: "delivery_from",
          selector: "delivery_from",
          sortable: true
        }
        ,
      {
          name: "delivery_to",
          selector: "delivery_to",
          sortable: true
        }
        ,
      {
        name: "total_weight",
        selector: "total_weight",
        sortable: true
      }
        ,
      {
        name: "total_price",
        selector: "total_price",
        sortable: true
      }
    ];
    const tableData = {
      columns,
      data
    };


  
 
  return (
    <div>
       <section className="your_business_page fw" style={{ backgroundImage:  `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
              <div className="container"><div className="row">
                    <div className="col-md-12 col-sm-12 your_business text-center">
                        <div className="business_content">
                            <h2>Wallet Transactions</h2>
                            <p><a className="" style={{cursor: "pointer", textDecoration: "underline"}} onClick={walletDashboard_logout}>- Logout -</a></p>
                           
                        </div>
                    </div>
                </div>
                </div>
            </section>
        <div className="pages_content">
            <div className="container">
            <div className="row">
            <div id="primary" className="content-area" style={{float: 'left', width: '100%'}}>
            <main id="main" className="site-main" role="main">
           <div className="entry-content">
           <div className="become_driver">
           {isload?(
  <div style={{textAlign:"center"}}>
  <p style={{textAlign:"center"}}>Please wait. The data is loading ! </p>
  <img src={loading} alt="" style={{width:"4%"}}  />
  </div>
):(<DataTableExtensions {...tableData}>
  <DataTable
    columns={columns}
    data={data}
    noHeader
    defaultSortField="id"
    // sortIcon={<SortIcon />}
    defaultSortAsc={true}
    pagination
    highlightOnHover
    dense
  />
</DataTableExtensions>
)}
             </div>


            </div>
            </main>
            </div>
            </div>
            </div>
            </div>
    </div>
  )
}
